import React from "react";
import { NavLink } from "react-router-dom";
import styled from 'styled-components';
import translate from "../../../providers/i18n/translate";
import { ThemeContext } from "../../../providers/theme";
import hasScope from "../../../providers/authentication/hasScope";

/* Styled components */
const Root = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`

const Nav = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
    height: 40px;
    border-top: 1px solid ${props => props.border ? props.border : "#000"};
    border-bottom: 1px solid ${props => props.border ? props.border : "#000"};
    background-color:  ${props => props.theme.palette.principal};
    @media (min-width: 1024px) {
        justify-content: flex-start;
    }
`

const Divider = styled.div`
    display: none;
    width: 1px;
    height: 95%;
    background-color: ${props => props.color ? props.color : "#000"};
    @media (min-width: 1024px) {
        display: inherit;
    }
`

const Item = styled(NavLink)`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-decoration: none;
    color: ${(props) => props.color ? props.color : "#D1AC00"};
    font-size: 1rem;
    text-transform: uppercase;
    opacity: 0.5;
    margin: 0;
    &.active {
        opacity: 1;
    }
    @media (min-width: 1024px) {
        font-size: 1rem;
        margin: 0 20px;
    }
`

const Content = styled.div`
    position: relative;
    width: 100%;
    height: calc(100% - 30px);
    overflow-y: auto;
`

const ClinicHistoryNav = ({children}) => {

    const theme = React.useContext(ThemeContext);

    return (
        <Root>
            <Nav>
                {/* Legacy tabs, se dejan para mantener la funcionalidad si es necesaria a futuro
                 {
                    hasScope("appointmentsTab") && (
                        <>
                            <Item to="" end color={theme.palette.base}>{translate("appointments")}</Item>
                            <Divider color={theme.palette.base} />
                        </>
                    )
                }
                {
                    hasScope("interventionsTab") && (
                        <>
                            <Item to="interventions" color={theme.palette.base}>{translate("interventions")}</Item>
                            <Divider color={theme.palette.base} />
                        </>
                    )
                }
                {
                    hasScope("treatmentsTab") && (
                        <>
                            <Item to="treatments" color={theme.palette.base}>{translate("treatments")}</Item>
                            <Divider color={theme.palette.base} />
                        </>
                    )
                } */}
                {
                    hasScope("generalClinicTab") && (
                        <>
                            <Item to="" end color={theme.palette.base}>{translate("generalClinic")}</Item>
                            <Divider color={theme.palette.base} />
                        </>
                    )
                }
                {
                    hasScope("healthTab") && (
                        <>
                            <Item to="health" color={theme.palette.base}>{translate("health")}</Item>
                            <Divider color={theme.palette.base} />
                        </>
                    )
                }
                {
                    hasScope("farrieryTab") && (
                        <>
                            <Item to="farriery" color={theme.palette.base}>{translate("farriery")}</Item>
                            <Divider color={theme.palette.base} />
                        </>
                    )
                }
            </Nav>
            <Content>
                {children}
            </Content>
        </Root>
    );
}

export default ClinicHistoryNav;